import React from 'react';

interface IDownloadLinkProps {
  downloadUrl: string;
  onMouseOverLink: () => void;
  onMouseExitLink: () => void;
}

const DownloadLink: React.SFC<IDownloadLinkProps> = (props: IDownloadLinkProps) => (
  <div
    className="download-link"
    onMouseEnter={props.onMouseOverLink}
    onMouseLeave={props.onMouseExitLink}
    onTouchStart={props.onMouseOverLink}
    onTouchEnd={props.onMouseExitLink}
  >
    <div>
      <a href={props.downloadUrl} target="_blank">
        Download Original Document
      </a>
    </div>
  </div>
);

export default DownloadLink;
